const PDFJS_VERSION = '3.11.174';
const PDFJS_SCRIPT_SRC = `js/vendor/pdf/pdf.min.js?v=20260706d${PDFJS_VERSION}`;
const PDFJS_WORKER_SRC = `js/vendor/pdf/pdf.worker.min.js?v=20260706d${PDFJS_VERSION}`;
const PDFJS_SCRIPT_ID = 'ks-pdfjs-runtime';

let pdfLibraryPromise = null;

function getLoadedPdfLibrary() {
  return typeof window !== 'undefined' ? window.pdfjsLib || null : null;
}

function configurePdfLibrary(pdfjs) {
  if (!pdfjs) throw new Error('PDF-Bibliothek nicht verfügbar. Bitte Seite neu laden.');
  pdfjs.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;
  return pdfjs;
}

function getPdfLibrary() {
  const loaded = getLoadedPdfLibrary();
  if (loaded) return configurePdfLibrary(loaded);
  if (pdfLibraryPromise) return pdfLibraryPromise;
  if (typeof document === 'undefined') {
    throw new Error('PDF-Bibliothek kann nur im Browser geladen werden.');
  }

  pdfLibraryPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(PDFJS_SCRIPT_ID);
    const script = existingScript || document.createElement('script');
    if (existingScript?.dataset?.loaded === 'true') {
      const pdfjs = getLoadedPdfLibrary();
      if (pdfjs) {
        resolve(configurePdfLibrary(pdfjs));
        return;
      }
    }

    const handleLoad = () => {
      const pdfjs = getLoadedPdfLibrary();
      if (!pdfjs) {
        reject(new Error('PDF-Bibliothek konnte nicht initialisiert werden.'));
        return;
      }
      script.dataset.loaded = 'true';
      resolve(configurePdfLibrary(pdfjs));
    };
    const handleError = () => {
      reject(new Error('PDF-Bibliothek konnte nicht geladen werden.'));
    };

    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });

    if (!existingScript) {
      script.id = PDFJS_SCRIPT_ID;
      script.src = PDFJS_SCRIPT_SRC;
      script.type = 'text/javascript';
      script.async = true;
      document.head.appendChild(script);
    } else {
      setTimeout(() => {
        const pdfjs = getLoadedPdfLibrary();
        if (pdfjs) handleLoad();
      }, 0);
    }
  }).catch(error => {
    pdfLibraryPromise = null;
    throw error;
  });

  return pdfLibraryPromise;
}

export {
  getPdfLibrary,
  configurePdfLibrary,
  getLoadedPdfLibrary
};
